import { Controller } from "@hotwired/stimulus"

const ENTER_FROM = [ "opacity-0", "-translate-x-4" ]
const ENTER_TO   = [ "opacity-100", "translate-x-0" ]
const EXIT_MS    = 200

const PALETTE = {
  notice:  { icon: "bi-check-circle-fill", iconClass: "text-brand-teal-light" },
  success: { icon: "bi-check-circle-fill", iconClass: "text-brand-teal-light" },
  alert:   { icon: "bi-exclamation-triangle-fill", iconClass: "text-[#F1998F]" },
  error:   { icon: "bi-exclamation-triangle-fill", iconClass: "text-[#F1998F]" },
  info:    { icon: "bi-info-circle-fill", iconClass: "text-white" }
}

export default class extends Controller {
  static targets = [ "container" ]
  static values  = {
    duration: { type: Number, default: 4000 },
    flashes:  { type: Object, default: {} },
    action:   { type: Object, default: {} }
  }

  connect() {
    Object.entries(this.flashesValue).forEach(([kind, message]) => {
      if (!message) return
      const action = [ "notice", "success", "info" ].includes(kind) ? this.actionValue : null
      this.#render(message, kind, action)
    })
  }

  // Called by data-action="toast:show@window->toast#receive"
  receive({ detail: { message, kind, action } = {} }) {
    if (message) this.#render(message, kind, action)
  }

  dismiss(event) {
    const toast = event.currentTarget.closest("[data-toast]")
    if (toast) this.#dismiss(toast)
  }

  #render(message, kind = "notice", action = null) {
    const node = this.#build(message, kind, action)
    this.containerTarget.appendChild(node)
    requestAnimationFrame(() => {
      node.classList.remove(...ENTER_FROM)
      node.classList.add(...ENTER_TO)
    })
    const duration = action?.url ? 8000 : this.durationValue
    setTimeout(() => this.#dismiss(node), duration)
  }

  #build(message, kind, action) {
    const palette = PALETTE[kind] || PALETTE.notice
    const li = document.createElement("li")
    li.dataset.toast = ""
    li.className = [
      "pointer-events-auto flex items-start gap-2.5 rounded-[9px] px-[18px] py-3 text-[15px] font-semibold shadow-float max-w-sm",
      "bg-ink text-white",
      "transition duration-200 ease-out",
      ...ENTER_FROM
    ].join(" ")

    const icon = document.createElement("i")
    icon.className = `bi ${palette.icon} ${palette.iconClass} mt-0.5 shrink-0`

    const body = document.createElement("p")
    body.className = "flex-1"
    const text = document.createElement("span")
    text.textContent = message
    body.appendChild(text)

    if (action?.url && action?.label) {
      const link = document.createElement("a")
      link.href = action.url
      link.textContent = action.label
      link.className = "block mt-1 text-brand-light font-semibold underline underline-offset-2"
      if (action.method) link.dataset.turboMethod = action.method
      body.appendChild(link)
    }

    const close = document.createElement("button")
    close.type = "button"
    close.dataset.action = "toast#dismiss"
    close.setAttribute("aria-label", "Dismiss notification")
    close.className = "shrink-0 -my-1 -mr-1 p-1 rounded text-[#9FB0C4] hover:text-white hover:bg-white/10 cursor-pointer"
    close.innerHTML = `<i class="bi bi-x-lg text-meta"></i>`

    li.append(icon, body, close)
    return li
  }

  #dismiss(toast) {
    if (toast.dataset.dismissed === "true") return
    toast.dataset.dismissed = "true"
    toast.classList.remove(...ENTER_TO)
    toast.classList.add(...ENTER_FROM)
    setTimeout(() => toast.remove(), EXIT_MS)
  }
}
